import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CurrentOrder from "./CurrentOrder";
import CancelledOrder from "./CancelledOrder";
import ReplacementOrder from "./ReplacementOrder";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Orders = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section className="pb-4" style={{ paddingTop: "6rem" }}>
        <Container>
          <div>
            <p className="title-para">Home - My Orders</p>
            <h2 className="title-navhead">My Orders</h2>
          </div>
          <div>
            <Box sx={{ width: "100%" }}>
              <Box>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="My Orders" {...a11yProps(0)} />
                  <Tab label="Cancelled Orders " {...a11yProps(1)} />
                  <Tab label="Replacement Orders" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <CurrentOrder/>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <CancelledOrder/>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <ReplacementOrder/>
              </CustomTabPanel>
            </Box>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Orders;
